import {
  Alert,
  AppBar,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import { useEffect } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { secondsInHour } from "date-fns/constants/index";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import "./expenseClaim.css";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const companyUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

const ExpenseClaimForm = (props) => {
  const {
    open,
    editRowOpen,
    viewRowOpen,
    viewRowMainOpen,
    handleClose,
    handleAdd,
    handleEdit,
    addRow,
    editRow,
    viewRow,
    handleAddNewRow,
    rowData,
  } = props;
  const [companyName, setCompanyName] = useState("");

  return (
    <>
      <Dialog open={editRowOpen} fullWidth maxWidth="sm" component="form">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Payment Details
            </Typography>
            <IconButton onClick={handleClose}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
          <Grid container>
            <Grid xs={12} item>
              <Grid container spacing={2} className="pb-16">
                <Grid xs={4} item>
                  <div>
                    <label>Payment Type</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="payment-type"
                      variant="outlined"
                      fullWidth
                      value={companyName}
                      disabled
                    />
                  </Stack>
                </Grid>
                <Grid xs={4} item>
                  <div>
                    <label>Doc No</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="doc-no"
                      variant="outlined"
                      fullWidth
                      value={editRow.docNo}
                      disabled
                    />
                  </Stack>
                </Grid>
                <Grid xs={2} item>
                  <div>
                    <label>Doc Date</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="doc-date"
                      variant="outlined"
                      fullWidth
                      value={editRow.docDate}
                      disabled
                    />
                  </Stack>
                </Grid>
                <Grid xs={2} item>
                  <div>
                    <label>Euro Rate</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="doc-date"
                      variant="outlined"
                      fullWidth
                      value={editRow.docDate}
                      disabled
                    />
                  </Stack>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="pb-16">
                <Grid xs={4} item>
                  <div>
                    <label>To</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="doc-date"
                      variant="outlined"
                      fullWidth
                      value={companyName}
                      disabled
                    />
                  </Stack>
                </Grid>
                <Grid xs={8} item>
                  <div>
                    <label>Name</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="doc-date"
                      variant="outlined"
                      fullWidth
                      value={editRow.employeeName}
                      disabled
                    />
                  </Stack>
                </Grid>
              </Grid>

              <Grid container spacing={2} className="pb-16">
                <Grid xs={4} item>
                  <div>
                    <label>Bank</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="bank"
                      variant="outlined"
                      fullWidth
                      value={companyName}
                      disabled
                    />
                  </Stack>
                </Grid>
                <Grid xs={4} item>
                  <div>
                    <label>Chq No.</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="chq-no"
                      variant="outlined"
                      fullWidth
                      value={companyName}
                      disabled
                    />
                  </Stack>
                </Grid>
                <Grid xs={2} item>
                  <div>
                    <label>Amount</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="amount"
                      variant="outlined"
                      fullWidth
                      value={companyName}
                      disabled
                    />
                  </Stack>
                </Grid>
                <Grid xs={2} item>
                  <div>
                    <label>Currency</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="amount"
                      variant="outlined"
                      fullWidth
                      value={companyName}
                      disabled
                    />
                  </Stack>
                </Grid>
              </Grid>
              <Grid container className="pb-16">
                <Grid xs={12} item>
                  <div>
                    <label>Description</label>
                  </div>
                  <Stack>
                    <StyledTextField
                      type="text"
                      name="bank"
                      variant="outlined"
                      fullWidth
                      value={companyName}
                      disabled
                    />
                  </Stack>
                </Grid>
              </Grid>
              <Typography
                className="text-lg font-medium p-12 pl-24 pr-24"
                sx={{ background: "#373c42", margin: "0 -23px 20px" }}
              >
                Allocation
              </Typography>
              <Grid container spacing={2} className="pb-16">
                <Grid xs={4} item>
                  <Typography className="text-lg font-medium pl-24 pr-24">
                    JV 2309673
                  </Typography>
                </Grid>
                <Grid xs={4} item>
                  <Typography className="text-lg font-medium pl-24 pr-24">
                    25001-1-1
                  </Typography>
                </Grid>
                <Grid xs={4} item>
                  <Typography className="text-lg font-medium pl-24 pr-24">
                    STAFF IMP
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ExpenseClaimForm;
